import { Link } from "react-router-dom";

const FRIEND_LINKS = [
  { label: "高清电影资料库", to: "/category" },
  { label: "影片剧情介绍", to: "/category" },
  { label: "演员资料索引", to: "/detail/se-jie" },
  { label: "影视资讯频道", to: "/news" },
];

const SITE_LINKS = [
  { label: "首页", to: "/" },
  { label: "影视分类", to: "/category" },
  { label: "影视资讯", to: "/news" },
  { label: "站内搜索", to: "/search" },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-shell px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-accent-400">
                <i className="ri-movie-2-fill text-[22px]" />
              </span>
              <div>
                <p className="font-heading text-lg font-bold text-foreground-950">色戒完整版无删减hd</p>
                <p className="font-label text-[11px] uppercase tracking-[0.2em] text-foreground-500">
                  Uncut · HD Movie Portal
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-foreground-600">
              一个专注高清影视内容展示与资讯整理的观影门户，提供影片资料、剧情介绍、演员信息与行业动态，
              帮助你在看片之前先了解影片本身。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["高清修复", "影片资料", "影人档案", "影视资讯"].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-600"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-foreground-950">站内导航</h4>
            <ul className="mt-4 space-y-2.5">
              {SITE_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-accent-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-semibold text-foreground-950">友情链接</h4>
            <ul className="mt-4 space-y-2.5">
              {FRIEND_LINKS.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-600 transition-colors hover:text-accent-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-semibold text-foreground-950">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-500" />
                <span>content@sejie-hd.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-500" />
                <span>工作日 10:00 – 18:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5 text-accent-500" />
                <span>内容更正与资料补充欢迎来信</span>
              </li>
            </ul>
            <div className="mt-5 flex gap-2">
              {[
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-mail-send-line", label: "邮件" },
              ].map((item) => (
                <button
                  key={item.label}
                  type="button"
                  aria-label={item.label}
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-accent-400 hover:text-accent-600"
                >
                  <i className={item.icon} />
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 色戒完整版无删减hd · 本站为影视内容展示演示站点，不提供在线播放与下载。</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-500" />
            内容仅用于资料展示与影迷交流
          </p>
        </div>
      </div>
    </footer>
  );
}